import { ATSPrincipalAppCandidateModalHeaderTestIds } from 'data-testids/ATS';
import { Box, Typography, useTheme } from '@mui/material';
import { CandidateModalHeaderProps } from 'features/Principal/types/modalTypes';
import {
  CredentialVerifiedBadge,
  HighlyRelevantSkillsBadge,
  HighRetentionPossibleBadge,
} from 'sharedComponents/Badge/CandidateBadges';
import { CandidateCredentialStatus } from 'utils/typedEnums';

export const CandidateModalHeader: React.FC<CandidateModalHeaderProps> = ({ row }) => {
  const theme = useTheme();
  const isVerified =
    row.candidate.candidate_credential_status === CandidateCredentialStatus.ALL_VERIFIED ||
    row.candidate.candidate_credential_status === CandidateCredentialStatus.SOME_VERIFIED;

  return (
    <Box>
      <Typography
        data-testid={ATSPrincipalAppCandidateModalHeaderTestIds.CANDIDATE_NAME}
        sx={{ color: theme.palette.text.primary, mb: theme.spacing(1) }}
        variant="h2"
      >
        {row?.candidate.first_name}
        {'\u00A0'}
        {row?.candidate.last_name}
      </Typography>
      <Typography
        data-testid={ATSPrincipalAppCandidateModalHeaderTestIds.JOB_TITLE}
        variant="heading7"
      >
        {row?.role.title}
      </Typography>
      {row?.application?.high_retention && (
        <HighRetentionPossibleBadge
          dataTestId={ATSPrincipalAppCandidateModalHeaderTestIds.HIGH_RETENTION_BADGE}
          showText
        />
      )}
      {row?.application?.top_candidate && (
        <HighlyRelevantSkillsBadge
          showText
          dataTestId={ATSPrincipalAppCandidateModalHeaderTestIds.HIGHLY_RELEVANT_SKILLS_BADGE}
        />
      )}
      {isVerified && (
        <CredentialVerifiedBadge
          dataTestId={ATSPrincipalAppCandidateModalHeaderTestIds.CREDENTIALS_VERIFIED_BADGE}
          showText
        />
      )}
    </Box>
  );
};
